import { OrderInfoProvider } from "entities/orders"
import { Body } from "../../style"
import { OrderDetail } from "widgets/orderDetail"
import { Guests } from "features/hallmapToolbar/guests"
import { Flex } from "shared/ui/flex"
import { DatePicker } from "features/hallmapToolbar/datePicker"
import { useAppSelector } from 'shared/lib/store';
import { selectSelectedTimeslot, useTimeslot, useTimeslotZone } from 'entities/toolbar/timeslots';
import { useGetSlotsByDate } from 'features/hallmapToolbar/datePicker/lib/useGetSlotsByDate';
import { CurrentTimeSwitch } from 'features/hallmapToolbar/currentTimeSwitch';
import { SECONDARY_BG_COLOR } from "shared/consts"

export const MobileIndexWait = () => {
  const selectedTimeslot = useAppSelector(selectSelectedTimeslot);
  const { getSlotsByDate } = useGetSlotsByDate();
  const { formatISODateBySlotZone } = useTimeslotZone();
  const { toTimeslot } = useTimeslot();

  const onDateChange = async (date: Date) => {
    if (!date) {
      return;
    }

    const newTimeslotDate = new Date(selectedTimeslot);
    newTimeslotDate.setFullYear(date.getFullYear(), date.getMonth(), date.getDate());
    toTimeslot(formatISODateBySlotZone(newTimeslotDate), { clear: true })
    getSlotsByDate(date);
  }

  return (
    <Body>
      <Flex
        $justify="space-between"
        $padding="16px 15px 0"
        $background={SECONDARY_BG_COLOR}
      >
        <DatePicker onChange={onDateChange} value={selectedTimeslot ? new Date(selectedTimeslot) : new Date()} />
        <CurrentTimeSwitch />
      </Flex>
      <OrderInfoProvider>
        <OrderDetail includePenButtonInPerson={false} minusHeight='147px'/>
        <Guests />
      </OrderInfoProvider>
    </Body>
  )
}